import { useState } from "react";
import { toast } from "sonner";
import { submitScore } from "@/lib/api";

export const useEndActions = ({ t, lang, score, turn, titleKey, reason, meters, years, months, title, defaultNick }) => {
  const [nick, setNick] = useState(() => defaultNick || localStorage.getItem("ps_nick") || "");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    const nickname = nick.trim();
    if (!nickname) return;
    setBusy(true);
    try {
      localStorage.setItem("ps_nick", nickname);
      await submitScore({ nickname, score, turns: turn, title_key: titleKey, outcome: reason, meters, lang });
      setSent(true);
      toast.success(t.submitted);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Error");
    } finally {
      setBusy(false);
    }
  };

  const share = async () => {
    const text = t.shareText(years, months, title, score);
    const url = window.location.origin;
    try {
      if (navigator.share) {
        await navigator.share({ text, url });
        return;
      }
      await navigator.clipboard.writeText(`${text} ${url}`);
      toast.success(t.copied);
    } catch (e) {
      if (e?.name !== "AbortError") toast.error(e?.message || "Share failed");
    }
  };

  return { nick, setNick, sent, busy, submit, share };
};
